'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


/**
 * Provides state management for components that can be in either an editable or read only state.
 */
exports.default = function (DecoratedComponent) {
    var ReadOnlyOrEditableDecorator = function (_React$Component) {
        _inherits(ReadOnlyOrEditableDecorator, _React$Component);

        function ReadOnlyOrEditableDecorator(props) {
            _classCallCheck(this, ReadOnlyOrEditableDecorator);

            var _this = _possibleConstructorReturn(this, (ReadOnlyOrEditableDecorator.__proto__ || Object.getPrototypeOf(ReadOnlyOrEditableDecorator)).call(this, props));

            _this.toggleEditing = function () {
                _this.setState({ isEditing: !_this.state.isEditing });
            };

            _this.startEditing = function () {
                _this.setState({ isEditing: true });
            };

            _this.stopEditing = function () {
                _this.setState({ isEditing: false });
            };

            _this.state = { isEditing: false };
            return _this;
        }

        _createClass(ReadOnlyOrEditableDecorator, [{
            key: 'render',
            value: function render() {
                var isEditing = this.state.isEditing;

                return _react2.default.createElement(DecoratedComponent, _extends({
                    isEditing: isEditing,
                    toggleEditing: this.toggleEditing,
                    startEditing: this.startEditing,
                    stopEditing: this.stopEditing
                }, this.props));
            }
        }]);

        return ReadOnlyOrEditableDecorator;
    }(_react2.default.Component);

    ReadOnlyOrEditableDecorator.propTypes = {};

    return ReadOnlyOrEditableDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/readOnlyOrEditableDecorator.js
// module id = 702
// module chunks = 0